/* Forte3D Custom Fixes — APO Product Options compatibility with Spotlight theme */

document.addEventListener('DOMContentLoaded', function() {
  /* === TASK 2: Fix Product Image Spacing === */
  /* Collapse empty APO containers via MutationObserver */
  var observer = new MutationObserver(function() {
    /* Old-style APO containers */
    document.querySelectorAll('.mw-product-options').forEach(function(el) {
      var hasVisibleChildren = Array.from(el.children).some(function(child) {
        return child.offsetHeight > 0;
      });
      if (!hasVisibleChildren) {
        el.style.display = 'none';
        el.style.height = '0';
        el.style.overflow = 'hidden';
      } else {
        el.style.display = '';
        el.style.height = '';
        el.style.overflow = '';
      }
    });

    /* New-style APO app block containers */
    document.querySelectorAll('.shopify-app-block').forEach(function(el) {
      var isMageworx = el.querySelector('script[src*="mws_apo"]') ||
                       el.querySelector('script[src*="mageworx"]');
      if (isMageworx) {
        var hasVisibleContent = Array.from(el.children).some(function(child) {
          return child.offsetHeight > 0 && child.tagName !== 'SCRIPT' && child.tagName !== 'LINK';
        });
        if (!hasVisibleContent) {
          el.style.margin = '0';
          el.style.padding = '0';
          el.style.height = '0';
          el.style.overflow = 'hidden';
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* === Auto-scroll to product image when APO swatch is tapped === */
  /* When a customer picks a design, scroll up so they can see the change */
  var productMedia = document.querySelector('.product__media-wrapper') ||
                     document.querySelector('.product__media-list');

  if (productMedia) {
    /* Watch for clicks on APO swatch/option images */
    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[class*="mw"] img, [class*="mw"] label, [class*="mw"] button, [class*="mw"] [data-option], .shopify-app-block img, .shopify-app-block label');
      if (!swatch) return;

      /* Small delay to let APO update the product image first */
      setTimeout(function() {
        productMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    });

    /* Also watch for APO changing the main product image via DOM mutation */
    var imgObserver = new MutationObserver(function(mutations) {
      var imageChanged = mutations.some(function(m) {
        return m.type === 'attributes' && m.attributeName === 'src' &&
               m.target.tagName === 'IMG' &&
               m.target.closest('.product__media-item, .product-media-container, modal-opener');
      });
      if (imageChanged) {
        productMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    imgObserver.observe(productMedia, {
      attributes: true,
      attributeFilter: ['src', 'srcset'],
      subtree: true
    });
  }
});

/** Fix added 7/23/26 by Jack Ford - Update Shopify store UI
 * 
 * Hides "Upload Your Artwork" button and moves buttons
 * below the variants
 * 
 * NOTE: I really thought these would be settings, and if they are, 
 * those settings will not work while this code is active
 */

function editCSS() {
    const labels = document.querySelectorAll("legend.form__label");
    const pp = document.getElementById("pp_main_btn_sec");

    labels.forEach(e => {
      e.style.fontWeight = "bold";
      e.style.fontSize = "20px";
    });

    if (labels.length > 1) {
      labels[0].parentNode.style.margin = "50px 0px 40px 0px";
      labels[1].style.margin = "0px 0px 0px 0px";
    }
    else {
      labels[0].style.margin = "50px 0px 0px 0px";
    }
    
    pp.style.margin = "12px 0px 50px";
}

function addUpdateUIHook() {
    // Move "Customize" button above quantity button
    const pp = document.getElementById("pp_main_btn_sec");
    const quantity = document.querySelector('.product-form__quantity');
    quantity.parentNode.insertBefore(pp, quantity);

    // Add form text above customize button
    const variants = document.querySelector('variant-selects');
    const text = document.createElement("legend");
    text.classList.add("form__label");
    if (variants) {
      text.textContent = "Step 2: Design your instrument";
    }
    else {
      text.textContent = "Design your instrument";
    }
    
    pp.parentNode.insertBefore(text, pp);

    // Change CSS
    editCSS();

    // Hide "Upload Your Artwork" button
    const original = ppclient._setBtnPref;
    ppclient._setBtnPref = function () {
      original.apply(this, arguments);

      if (this._ui && this._ui.uploadBtn) {
        this._ui.uploadBtn.style.display = "none";
      }
    };

    // Subscribe to variant change event
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      // Reapply CSS changes
      editCSS();
    });


    console.log("UI patch appplied successfully");
}

/** Fix added 7/23/26 by Jack Ford - Disable radios on submission
 * 
 * This code fixes an issue where you could still select variants
 * with a design active, which looked bad for users because they
 * could select a different variant, but when they edited it, it
 * would be there old design. This fixes that by disabling the radio
 * buttons on submission and when a page is loaded with a design.
 * 
 */
function addDisableRadiosHook() {
    function disableAllRadios() {
      document.querySelectorAll('input[type="radio"][name^="Step 1"]')
        .forEach(radio => {
          radio.disabled = true;
        });
    }

    if (ppclient._vars.autoInitialize) {
      disableAllRadios();
    }

    ppclient.on("project-saved", () => {
      disableAllRadios();
    });

    console.log("Radio patch appplied successfully");
}

/**
 * Wait for PitchPrint to initialize, then apply all custom patches.
 * Do this so we aren't waiting twice for ppclient to init and so that
 * these fixes only apply to products where PitchPrint is active
 * 
 * Added 7/23/26 by Jack Ford
 */
(function waitForPitchPrint() {
  const interval = setInterval(() => {

    if (!window.ppclient || typeof ppclient.on !== "function")
      return;

    clearInterval(interval);
    addUpdateUIHook();
    addDisableRadiosHook();

    console.log("All patches appplied successfully");
  }, 100);
})();

/**
 * Added 10/12/26: last art pick shows on top
 *
 * Globo draws Top Art and Back Art as two full-size layers in the same
 * spot, with Back always on top, so changing the top art after picking
 * a back looked like nothing happened. This brings whichever art layer
 * just changed to the front of the preview.
 * Safe to remove if Globo adds layer ordering or the preview is redone.
 */
(function lastPickOnTop() {
  function srcOf(n) {
    var im = n.image && n.image();
    return im && typeof im.src === 'string' ? im.src : '';
  }
  function imageNodes() {
    if (!window.Konva || !Konva.stages) return [];
    var out = [];
    Konva.stages.forEach(function (s) {
      s.find('Image').forEach(function (n) { out.push(n); });
    });
    return out;
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.gpo-element')) return;
    var before = new Map();
    imageNodes().forEach(function (n) { before.set(n, srcOf(n)); });
    var started = Date.now();
    var timer = setInterval(function () {
      imageNodes().forEach(function (n) {
        var s = srcOf(n);
        /* only art layers (data: images), never the base product photo */
        if (s.indexOf('data:') === 0 && s !== before.get(n) && n.parent &&
            n.zIndex() !== n.parent.children.length - 1) {
          n.moveToTop();
          if (n.getLayer()) n.getLayer().batchDraw();
        }
      });
      if (Date.now() - started > 4000) clearInterval(timer);
    }, 100);
  }, true);
})();

/**
 * Added 10/12/26: smaller cart preview image (faster Add to cart)
 *
 * At Add to cart, Globo uploads a copy of the preview as a ~1.3 MB PNG
 * before the item goes in the cart (this took ~6 seconds). This shrinks
 * only that uploaded copy to a half-size JPEG (~70 KB). The preview on
 * the product page is not touched and stays full resolution.
 * If anything goes wrong, the original image is sent unchanged.
 */
(function smallerGloboUpload() {
  if (!window.fetch || !window.FormData || !window.createImageBitmap) return;
  var originalFetch = window.fetch;

  function shrink(file) {
    return createImageBitmap(file).then(function (bmp) {
      var w = Math.round(bmp.width / 2), h = Math.round(bmp.height / 2);
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var g = c.getContext('2d');
      g.fillStyle = '#ffffff';            /* JPEG has no transparency */
      g.fillRect(0, 0, w, h);
      g.drawImage(bmp, 0, 0, w, h);
      return new Promise(function (resolve) { c.toBlob(resolve, 'image/jpeg', 0.85); });
    });
  }

  window.fetch = function (input, init) {
    var self = this, args = arguments;
    var url = String((input && input.url) || input);
    var body = init && init.body;
    if (!/uploadPersonalize/.test(url) || !(body instanceof FormData)) {
      return originalFetch.apply(self, args);
    }
    var img = body.get('image');
    if (!img || !img.size || img.size < 200 * 1024) {
      return originalFetch.apply(self, args);
    }
    return shrink(img).then(function (jpg) {
      if (!jpg || jpg.size >= img.size) return originalFetch.apply(self, args);
      var fd = new FormData();
      body.forEach(function (value, key) {
        if (key === 'image') {
          fd.append('image', jpg, String(img.name || 'personalize').replace(/\.\w+$/, '') + '.jpg');
        } else {
          fd.append(key, value);
        }
      });
      return originalFetch.call(self, input, Object.assign({}, init, { body: fd }));
    }, function () {
      return originalFetch.apply(self, args);
    });
  };
})();

/**
 * Added 10/12/26: PitchPrint (design your own) fixes
 *
 * 1. PitchPrint puts its hidden design fields (properties[_pitchprint]
 *    etc.) into the FIRST cart form on the page, which in this theme is
 *    the Shop Pay installments form, not the real product form. So the
 *    customer's design was not being sent with Add to cart. This links
 *    those fields to the real product form (HTML "form" attribute).
 * 2. One second after Add to cart, PitchPrint reloads the page to clear
 *    the design, which wiped the cart popup (View cart / Check out).
 *    For Add to cart only, the reload is held off while the popup is
 *    open and done when the customer closes it (or after 6 seconds if
 *    the popup never opens), so the page still resets cleanly.
 *    "Start over" keeps PitchPrint's normal reload.
 */
(function pitchPrintFixes() {
  window.PPCLIENT = window.PPCLIENT || {};
  window.PPCLIENT.preventReload = false;

  function holdReloadForCartPopup() {
    window.PPCLIENT.preventReload = true;
    setTimeout(function () { window.PPCLIENT.preventReload = false; }, 3000);
    var popup = document.querySelector('#cart-notification');
    var opened = false, done = false;
    function reset() { if (!done) { done = true; window.location.reload(); } }
    if (popup) {
      new MutationObserver(function () {
        var active = popup.classList.contains('active');
        if (active) opened = true;
        else if (opened) reset();          /* customer closed the popup */
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    }
    setTimeout(function () { if (!opened) reset(); }, 6000);
  }

  var FIELD_IDS = ['_pitchprint', '_pprint-pdf-download', '_pprint-png-download'];

  function productFormId() {
    var f = document.querySelector('product-form form[action*="/cart/add"]');
    return f ? f.getAttribute('id') : null;
  }

  function linkFields() {
    var formId = productFormId();
    if (!formId) return;
    FIELD_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getAttribute('form') !== formId) el.setAttribute('form', formId);
    });
  }

  function start() {
    if (!document.querySelector('product-form')) return;
    linkFields();
    new MutationObserver(linkFields).observe(document.body, { childList: true, subtree: true });
    /* last check right before the theme reads the form */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('button[name="add"]')) {
        linkFields();
        var pp = document.getElementById('_pitchprint');
        if (pp && pp.value) holdReloadForCartPopup();
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/**
 * Added 10/12/26: show the customer's PitchPrint design as the main image
 *
 * When the customer submits their design, PitchPrint makes a preview
 * image of it. This puts that preview in place of the first product
 * photo (main image, zoom view and thumbnail). "Start over" puts the
 * original photo back. Display only: nothing in the cart or order changes.
 */
(function pitchPrintMainImage() {
  var saved = null;   /* original src/srcset/sizes of the swapped images */

  function targetImages() {
    var list = [];
    var main = document.querySelector('.product__media-list .product__media-item img');
    var zoom = document.querySelector('product-modal .product-media-modal__content img, .product-media-modal__content img');
    var thumb = document.querySelector('.thumbnail-list img');
    [main, zoom, thumb].forEach(function (img) { if (img) list.push(img); });
    return list;
  }

  function previewUrl() {
    var v = window.ppclient && window.ppclient._vars;
    var p = v && v.previews && v.previews[0];
    return p ? p + (p.indexOf('?') < 0 ? '?' : '&') + '_=' + Date.now() : null;
  }

  function show(url, triesLeft) {
    if (!url) return;
    var probe = new Image();
    probe.onload = function () {
      var imgs = targetImages();
      if (!saved) {
        saved = imgs.map(function (img) {
          return { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
        });
      }
      imgs.forEach(function (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', url);
      });
    };
    probe.onerror = function () {
      /* preview can take a moment to appear on PitchPrint's server */
      if (triesLeft > 0) setTimeout(function () { show(previewUrl() || url, triesLeft - 1); }, 1000);
    };
    probe.src = url;
  }

  function restore() {
    if (!saved) return;
    saved.forEach(function (s) {
      if (s.src !== null) s.img.setAttribute('src', s.src);
      if (s.srcset !== null) s.img.setAttribute('srcset', s.srcset);
      if (s.sizes !== null) s.img.setAttribute('sizes', s.sizes);
    });
    saved = null;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#pp_clear_design_btn')) restore();
  }, true);

  var waited = 0;
  var timer = setInterval(function () {
    waited += 200;
    if (waited > 20000) { clearInterval(timer); return; }
    if (!window.ppclient || typeof window.ppclient.on !== 'function') return;
    clearInterval(timer);
    window.ppclient.on('project-saved', function () {
      setTimeout(function () { show(previewUrl(), 5); }, 300);
    });
    /* design already in progress when the page loads */
    if (window.ppclient._vars && window.ppclient._vars.projectId) show(previewUrl(), 2);
  }, 200);
})();
